import React from 'react';
import styles from './OrderTable.module.scss';
import { XPagination, XTableSelectionCount, XTableHOC } from '@/components/xqxc_ui';
import { Table } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { regFenToYuan } from '@/util/money';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';

class OrderTable extends React.Component {

    state = {
        selectedRowKeys: []
    }

    _takeColumns = () => ([
        {
            title: '订单号',
            dataIndex: 'deliveryShowId',
            key: 'deliveryShowId',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltipClick(text, () => {
                this.props.tableAction(item.id, 'info', item);
            })
        },
        {
            title: '骑士帐号',
            dataIndex: 'riderPhone',
            key: 'riderPhone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士',
            dataIndex: 'riderName',
            key: 'riderName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发货信息',
            dataIndex: 'shipperPhone',
            key: 'shipperPhone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收货信息',
            dataIndex: 'consigneePhone',
            key: 'consigneePhone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '订单实付金额',
            dataIndex: 'payAmount',
            key: 'payAmount',
            width: cellWidth.normal,
            align: 'center',
            render: (text) => (this._renderTextMoneyCell(text))
        },
        {
            title: '小费',
            dataIndex: 'tips',
            key: 'tips',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text) => (this._renderTextMoneyCell(text))
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: cellWidth.normal,
            align: 'center',
            render: tooltip
        },
        {
            title: '订单类型',
            dataIndex: 'type',
            key: 'type',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '是否超时',
            dataIndex: 'isDelay',
            key: 'isDelay',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '实际送达',
            dataIndex: 'actualDeliverTime',
            key: 'actualDeliverTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '运营公司',
            dataIndex: 'opName',
            key: 'opName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '支付通道',
            dataIndex: 'payAccessType',
            key: 'payAccessType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '支付方式',
            dataIndex: 'payType',
            key: 'payType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'key',
            key: 'key',
            align: 'center',
            width: cellWidth.normal,
            fixed: 'right',
            render: (text, record) => this._renderActionCell(record.id, record)
        }
    ]);

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }
    _renderTextMoneyCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {regFenToYuan(text)}
            </div>
        );
    }
    _renderTextCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        );
    };
    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, 'history', record)}>订单日志</div>
            </div>
        );
    };

    // 表格复选输入
    _rowSelection = () => {
        const { selectedRowKeys } = this.state;
        return {
            selectedRowKeys,
            onChange: (selectedRowKeys) => {
                this.setState({ selectedRowKeys });
                this.props.tableAction(null, 'batch', [...selectedRowKeys]);
            }
        };
    };

    // 清空表格复选框
    _cleanAllSelected = () => {
        this.setState({ selectedRowKeys: [] });
        this.props.tableAction(null, 'batch', []);
    }

    render() {
        const { selectedRowKeys } = this.state;
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                {/* <XTableSelectionCount selectedNum={selectedRowKeys.length} onClean={this._cleanAllSelected} /> */}
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowSelection={this._rowSelection()}
                    rowKey={record => record.deliveryId}
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

OrderTable.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    scrollY: PropTypes.string
};

export default OrderTable;
